import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import { CreateGroupRequest } from '../Types/Requests/GroupRequests'
import { GroupResponse, ListGroupsResponse } from '../Types/Responses/GroupResponses'
export default class GroupService extends Service {
  prefix: string

  constructor() {
    super()

    this.prefix = '/groups'
  }

  async create(payload: CreateGroupRequest): Promise<GroupResponse> {
    try {
      const { data } = await request.post<GroupResponse>(`${this.getCompletePath()}`, payload)
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível criar o grupo.')
    }
  }

  // Sem `limit`, o backend devolve só os 20 primeiros grupos (com `count` do total).
  async list(limit?: number, offset?: number): Promise<ListGroupsResponse> {
    try {
      const { data } = await request.get<ListGroupsResponse>(this.getCompletePath(), {
        limit,
        offset
      })
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar os grupos.')
    }
  }

  async listByCompanies(companyIds: number[], page: number = 1, limit: number = 20) {
    const calculatedOffset = (page - 1) * limit
    const url = `${this.getCompletePath('/by-companies')}?companyIds=${companyIds.join(',')}&limit=${limit}&offset=${calculatedOffset}`
    try {
      const { data } = await request.get<ListGroupsResponse>(url)
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar os grupos das empresas selecionadas.')
    }
  }

  async remove(groupId: number): Promise<void> {
    try {
      await request.delete(`${this.getCompletePath()}/${groupId}`)
    } catch (e) {
      throw this.handleError(e, 'Não foi possível excluir o grupo.')
    }
  }

  async update(groupId: number, payload: CreateGroupRequest): Promise<void> {
    try {
      await request.put(`${this.getCompletePath()}/${groupId}`, payload)
    } catch (e) {
      throw this.handleError(e, 'Não foi possível atualizar o grupo.')
    }
  }
}
